import React, {useState, useEffect} from "react";
import {
    Button,
    Typography,
    Card,
    CardHeader,
    CardBody,
    IconButton,
    Menu,
    MenuHandler,
    MenuList,
    MenuItem,
    Avatar,
    Tooltip,
    Progress,
} from "@material-tailwind/react";
import {
    projectsTableData,
} from "../../data";
import RoleForm from '../shared/role_form';

import {
    EllipsisVerticalIcon,
    ArrowUpIcon,
} from "@heroicons/react/24/outline";
import SideNav from "../layout/sidenav";
import NavBar from "../layout/navbar";
import Footer from "../layout/footer";

const Invoices = (props) => {
    const [invoices, setInvoices] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [openSidenav, setOpenSidenav] = useState(false);
    const routes = {main: 'Inicio', current: 'Facturas'}


    useEffect(() => {
        fetch("/invoices.json")
            .then((response) => response.json())
            .then((data) => setInvoices(data))
            .catch((error) => console.error("Error fetching invoices:", error));
        console.log('invoices; ', invoices);
    }, []);

    if(selectedRole){
        return (
            <>
                <SideNav setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                <div className="p-4 xl:ml-80">
                    <NavBar routes={routes} setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                    <div className="flex flex-wrap mt-6">
                        <div className="w-full px-4">
                            <RoleForm cancel={() => setSelectedRole(null)}/>
                        </div>
                    </div>
                    <Footer/>
                </div>
            </>
        )
    } else {
        return (
            <>
                <SideNav setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                <div className="p-4 xl:ml-80">
                    <NavBar routes={routes} setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                    <div className="mt-12">
                        <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                        <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                                <CardHeader
                                    floated={false}
                                    shadow={false}
                                    color="transparent"
                                    className="m-0 flex items-center justify-between p-6"
                                >
                                    <div>
                                        <Typography variant="h6" color="blue-gray" className="mb-1">
                                            Facturas
                                        </Typography>
                                    </div>
                                </CardHeader>
                                <CardBody className="overflow-x-scroll px-0 pt-0 pb-2">
                                    <table className="w-full min-w-[640px] table-auto">
                                        <thead>
                                        <tr>
                                            {["Folio", "Clave", "Forma de pago", "Total", "Acciones"].map(
                                                (el) => (
                                                    <th
                                                        key={el}
                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                    >
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            {el}
                                                        </Typography>
                                                    </th>
                                                )
                                            )}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {invoices.map((invoice, key) => {
                                            const className = `py-3 px-5 ${
                                                key === invoices.length - 1 ? "" : "border-b border-blue-gray-50"
                                            }`;

                                            return (
                                                <tr key={invoice.id}>
                                                    <td className={className}>
                                                        <Typography variant="small" color="blue-gray"
                                                                    className="font-bold">
                                                            {invoice.parcel_code}
                                                        </Typography>
                                                    </td>
                                                    <td className={className}>
                                                        <Typography variant="small"
                                                                    className="text-xs font-medium text-blue-gray-600">
                                                            {invoice.payment_type.name}
                                                        </Typography>
                                                    </td>
                                                    <td className={className}>
                                                        <Typography variant="small"
                                                                    className="text-xs font-medium text-blue-gray-600">
                                                            {invoice.total}
                                                        </Typography>
                                                    </td>
                                                    <td className={className}>
                                                        <Typography variant="small"
                                                                    className="text-xs font-medium text-blue-gray-600">
                                                            {invoice.total}
                                                        </Typography>
                                                    </td>
                                                    <td className={className}>
                                                        <Menu placement="left-start">
                                                            <MenuHandler>
                                                                <IconButton size="sm" variant="text" color="blue-gray">
                                                                    ...
                                                                </IconButton>
                                                            </MenuHandler>
                                                            <MenuList>
                                                                <MenuItem
                                                                    onClick={() => setSelectedRole(lot.id)}>Editar
                                                                </MenuItem>
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        window.location.href = "/print_ticket/" + invoice.id;
                                                                    }}
                                                                >
                                                                    Imprimir Recibo
                                                                </MenuItem>
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        window.location.href = "/print_debts/" + invoice.parcel_code;
                                                                    }}
                                                                >
                                                                    Imprimir Estado de Cuenta de Adeudos
                                                                </MenuItem>

                                                                <MenuItem>
                                                                    Eliminar
                                                                </MenuItem>
                                                            </MenuList>
                                                        </Menu>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </CardBody>
                        </Card>
                        </div>
                    </div>
                    <Footer/>
                </div>
            </>
        );
    }
};

export default Invoices;